// extracted by mini-css-extract-plugin
export default {"senderInfo":"group-notification-sender_senderInfo__D6uj9"};